(function ($) {
   'use strict';
   var fetchPosts = require('./fetchPosts/index.js');
   /*
    * Search for account managers and
    */
   var account_manager_form = document.forms.search_account_manager;

   if(account_manager_form){
    // Do ajax call to the account managersthing

       account_manager_form.addEventListener('submit', function (ev) {
            ev.preventDefault();

            var value = this.querySelector('#city').value;

            if(value === ''){
                return false;
            }

            // do the ajax call.
            var fromData = formatDataObj($(this).serializeArray());
            fromData['action'] = 'search_account_manager';

            var $ajaxLoader = $('<div id="loading"></div>');
            var $account_manager_info = $('#account_manager_info');

           $account_manager_info.html($ajaxLoader);

           $.get(ajax_props.ajaxurl, fromData)
               .success(function (response) {
                   $ajaxLoader.remove();
                   var json = JSON.parse(response);

                   if(json.have_posts){
                       // set the html
                       $account_manager_info.html(json.html);

                       // get field model of the account_manager_email and the account_manager_name
                       var email_field = nfRadio.channel('form-3').request('get:fieldByKey', 'account_manager_email');
                       var name_field = nfRadio.channel('form-3').request('get:fieldByKey', 'account_manager_name');

                       // Set the field values!
                       email_field.set('value', json.email);
                       name_field.set('value', json.name);

                      document.getElementById('account-manager-regio').innerText = 'Regio: ' + value;

                   }else {
                       $account_manager_info.html('<p class="error">Er zijn geen accountmanagers voor deze plaats gevonden. Probeer te zoeken op de woonplaats vna het ziekenhuis of de grootste plaats in de buurt.</p>')
                   }
               })
               .fail(function (error) {
                   $ajaxLoader.fadeOut(1000);
                   console.warn(error);

                   setTimeout(function(){
                       $ajaxLoader.remove();
                   }, 1000);
               });
       });
   }

    function formatDataObj(data) {
        var new_data = {};

        data.map(function (item) {
            new_data[item.name] = item.value;
        });

        return new_data;
    }
}(jQuery));